// test1694
(1694 && 0);
